import { render, staticRenderFns } from "./ProductCategorySelector.vue?vue&type=template&id=3ded99f9&scoped=true"
import script from "./ProductCategorySelector.vue?vue&type=script&lang=js"
export * from "./ProductCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./ProductCategorySelector.vue?vue&type=style&index=0&id=3ded99f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded99f9",
  null
  
)

export default component.exports